import suggestEmail from 'utils/email_typo_suggestion';

export default class SignupEmailAssist {
  constructor(formSelector, options = {}) {
    this.form = document.querySelector(formSelector);

    if (!this.form) return;

    this.emailField = this.form.querySelector(`#${options.emailFieldId || 'registration_email'}`);
    this.suggestionContainer = this.form.querySelector(options.suggestionSelector || '.js-email-suggestion');

    this.bind();
  }

  bind() {
    if (!this.emailField) return;

    this.emailField.addEventListener('blur', () => this.handleEmailBlur());
    this.emailField.addEventListener('input', () => this.clearSuggestion());
  }

  handleEmailBlur() {
    const value = this.emailField.value.trim();

    if (!value) {
      this.clearSuggestion();
      return;
    }

    const suggestion = suggestEmail(value);

    if (!suggestion || suggestion.full.toLowerCase() === value.toLowerCase()) {
      this.clearSuggestion();
      return;
    }

    this.renderSuggestion(suggestion);
  }

  renderSuggestion(suggestion) {
    if (!this.suggestionContainer) return;

    const isNewSuggestion = !this.suggestionContainer.innerHTML;

    this.suggestionContainer.innerHTML = `
      <div class="q-email-suggestion">
        <span class="q-email-suggestion__text">
          Você quis dizer
          <button type="button" class="q-email-suggestion__link js-email-suggestion-accept">${suggestion.full}</button> ?
        </span>
        <button type="button" class="q-email-suggestion__dismiss js-email-suggestion-dismiss">Ignorar</button>
      </div>
    `;

    this.suggestionContainer
      .querySelector('.js-email-suggestion-accept')
      .addEventListener('click', () => this.acceptSuggestion(suggestion));

    this.suggestionContainer
      .querySelector('.js-email-suggestion-dismiss')
      .addEventListener('click', () => this.clearSuggestion());

    if (isNewSuggestion) {
      window.UserTracker?.emit('event', {
        eventName: 'email typo suggested',
        data: {
          'source platform': 'portal',
          'source project': gon?.source_project,
          request_path: window.location.pathname
        }
      });
    }
  }

  acceptSuggestion(suggestion) {
    window.UserTracker?.emit('event', {
      eventName: 'email typo suggestion accepted',
      data: {
        'source platform': 'portal',
        'source project': gon?.source_project,
        request_path: window.location.pathname
      }
    });

    this.emailField.value = suggestion.full;
    this.emailField.dispatchEvent(new Event('input', { bubbles: true }));
    this.emailField.dispatchEvent(new Event('change', { bubbles: true }));
    this.clearSuggestion();
  }

  clearSuggestion() {
    if (this.suggestionContainer) {
      this.suggestionContainer.innerHTML = '';
    }
  }
}
